import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  contents: {
    fontSzie: '14px !important',
    marginLeft: '8px',
  },

  cardArea: {
    '@media only screen and (max-width: 2560px)': {
      width: '344px',
      height: 323,
    },
    '@media only screen and (max-width: 1920px)': {
      width: '344px',
      height: 323,
    },
    '@media only screen and (max-width: 768px)': {
      width: '400px',
      height: 353,
    },

    '@media only screen and (max-width: 400px)': {
      width: '344px',
      height: 300,
    },

    '@media only screen and (max-width: 344px)': {
      width: '310px',
      height: 280,
    },
  },

  contentsArea: {
    height: '107px',
    '@media only screen and (max-width: 768px)': {
      '& p': {
        fontSize: '14px',
      },
    },

    '@media only screen and (max-width: 460px)': {
      '& p': {
        fontSize: '12px',
      },
    },
  },
  root: {
    marginBottom: '16px',
    marginRight: '16px',

    '@media only screen and (max-width: 768px)': {
      marginRight: 0,
    },
  },

  image: {
    border: '0 !important',
    height: '226px !important',
    '@media only screen and (max-width: 768px)': {
      height: '250px !important',
    },

    '@media only screen and (max-width: 460px)': {
      height: '204px !important',
      objectFit: 'fill',
    },
  },

  title: {
    fontWeight: 600,
    fontSzie: '18px !important',
    marginLeft: '8px',
    '@media only screen and (max-width: 768px)': {
      fontSize: '16px',
      fontWeight: 600,
    },

    '@media only screen and (max-width: 460px)': {
      fontSize: '14px',
      fontWeight: 600,
    },
  },
});
export default function CardItem(props) {
  const { handleClick = () => {}, data } = props;

  const image = data.image;
  const alt = data.contents;
  const title = data.title;
  const date = data.date;

  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Card onClick={handleClick} className={classes.cardArea}>
        <CardActionArea>
          <CardMedia component='img' className={classes.image} image={image} alt={alt} />
          <CardContent className={classes.contentsArea}>
            <Typography gutterBottom fontSize='18px' fontWeight='600' className={classes.title} component='div'>
              {title}
            </Typography>
            <Typography className={classes.sub} color='text.secondary'>
              {date}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
}
